import { IErrorsMap } from '../../interfaces';

const errorsMap: IErrorsMap = {
  "can't be blank": {
    first_name: 'This is required field',
    last_name: 'This is required field',
    cvv: 'This is required field',
    number: 'This is required field',
    year: 'Enter valid date',
    month: 'Enter valid date',
  },
  "can't be empty": {
    postal_code: 'This is required field',
  },
  'is invalid': {
    first_name: 'Enter valid First Name',
    last_name: 'Enter valid Last Name',
    cvv: 'Enter valid CVV',
    postal_code: 'Enter valid zip/ postal code',
    number: 'Enter valid credit card number',
    year: 'Enter valid date',
    month: 'Enter valid date',
  },
};

export default errorsMap;
